import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Route: /app/meetings/:id/attend — records attendance, then redirects into the meeting room.
 *  Handles the email "Attend Meeting" click.
 */
export default function MeetingAttendGate() {
  const { id } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await api.post(`/formal-meetings/${id}/attend`);
        toast.success("You're signed in — welcome to the meeting");
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Couldn't record attendance");
      } finally {
        nav(`/app/meetings/${id}`, { replace: true });
      }
    })();
  }, [id, nav]);

  return (
    <div className="p-16 text-center" data-testid="meeting-attend-gate">
      <div className="font-mono text-[11px] uppercase tracking-wider text-[#1a1a1a]/55 animate-pulse">Recording your attendance…</div>
    </div>
  );
}
